jQuery(function ($) {

  var sellingPlan = {
    weekly: 8023310379,
    fortnightly: 8023343147,
    oneTime: null
  };

  class CartDrawerSubmitButtonHandler {
    static listen() {
      const storePickupApp = document.querySelector('#storePickupApp');
      let found = false;
      const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          if (mutation.type === 'childList') {
            found = storePickupApp.querySelector('.ZapietStack');
          }
        }
        
        if (!found) {
          CartDrawerSubmitButtonHandler.setCheckoutButtonEnabled(false);
          if (typeof scToggleZapietCheckout === 'function') {
            scToggleZapietCheckout();
          }
          observer.disconnect();
        }
      });

      observer.observe(storePickupApp, {
        childList: true,
        subtree: true,
      });
    }

    static setCheckoutButtonEnabled(enabled) {
      console.log('setCheckoutButtonEnabled', enabled)
      const checkoutButton = document.querySelector('button[name="checkout"]');

      // Checkout button isn't activated yet - Might be no items in the cart or customer haven't been able to set delivery date etc...
      if (checkoutButton.hasAttribute('disabled')) return;

      if (enabled) {
        checkoutButton.setAttribute('disabled', 'true');
        checkoutButton.style.opacity = 0.5;
      } else {
        checkoutButton.removeAttribute('disabled');
        checkoutButton.style.opacity = 1;
        if (typeof scToggleZapietCheckout === 'function') {
          scToggleZapietCheckout();
        }
      }
    }
  }

  class SellingPlanHelper {

    static async getCartData() {
      const res = await fetch(`/cart.js`);

      if (!res.ok) {
        throw new Error('Failed to fetch cart: ', res.statusText);
      }

      return await res.json();
    }

    static async attachSellingPlanIDToCart(sellingPlanId) {
      window.activeSellingPlanId = sellingPlanId;
      document.dispatchEvent(new CustomEvent('subscription:started', { bubbles: true }));
      try {
        CartHelper.setActionablesEnabled(false);
        const entries = [];

        const data = await this.getCartData();

        for (const item of data.items) {
          const { variant_id, quantity, properties } = item;
          entries.push({
            id: variant_id,
            quantity,
            properties,
            selling_plan: sellingPlanId,
          });
        }

        entries.reverse(); // added by AMP

        const clearResponse = await fetch(`/cart/clear.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },

        });

        if (!clearResponse.ok) {
          throw new Error('Failed to clear cart: ', clearResponse.statusText);
        }

        const addResponse = await fetch(`/cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ items: entries }),
        });

        if (!addResponse.ok) {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ items: data.items })
          });
          throw new Error('Failed to update cart with selling plan ID: ', addResponse.statusText);
        }
      } catch (error) {
        throw error;
      } finally {
        CartHelper.setActionablesEnabled(true);
        document.dispatchEvent(new CustomEvent('subscription:updated', { bubbles: true }))
      }
    }

    static getSellingPlanLabel(sellingPlanId) {
      switch (sellingPlanId) {
        case sellingPlan.weekly:
          return 'Deliver every 1 week';
        case sellingPlan.fortnightly:
          return 'Deliver every 2 weeks';
        default:
          return 'One time';
      }
    }
  }

  class CartHelper {
    static setActionablesEnabled(enabled) {
      const cart = document.querySelector('#slidecarthq');

      const items = cart.querySelector('.items');
      if (items) {
        const itemsActionables = items.querySelectorAll('button');
        itemsActionables.forEach(button => {
          if (enabled == true) {
            button?.removeAttribute('disabled');
          } else {
            button?.setAttribute('disabled', enabled);
          }
        });
      }
    }

    static formatMoney(money = 0, currency = 'USD') {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency
      }).format(Number(money) / 100);
    }

    static createSellingPlanLabelElForCartItem (textContent = '') {
      const ul = document.createElement('ul');
      ul.classList.add('properties-key-value');
      const li = document.createElement('li');
      li.setAttribute('data-key', '');
      const span = document.createElement('span');
      span.classList.add('properties-key-value-value');
      span.innerText = textContent;
      
      return ul.appendChild(
        li.appendChild(span)
      );
    }

    static async updateCartUI() {
      const res = await fetch(`/cart.js`);
      const cart = await res.json();
      
      const totalPrice = cart.total_price;
      const cartItems = cart.items;

      const drawerItems = document.querySelectorAll('#slidecarthq .items .item');

      for (const item of drawerItems) {
        const titleEl = item.querySelector('span.title');
        if (!titleEl) continue;
        const titleText = titleEl.innerText;
        
        const foundCartItem = cartItems.find(item => item.product_title === titleText);
        if (!foundCartItem) continue;

        // get selling plan from the found cart item (fetched from /cart.js)
        const sellingPlan = foundCartItem?.selling_plan_allocation?.selling_plan;

        // Update subscription label for each cart item (drawer)
        const subscriptionEls = item.querySelectorAll('.main-top-left .properties-key-value-value');
        if (subscriptionEls.length) {
          if (sellingPlan) {
            for(const el of subscriptionEls) {
              el.innerHTML = sellingPlan.name; // weekly / fortnightly
            }
          } else {
            for (const el of subscriptionEls) {
              el.innerHTML = SellingPlanHelper.getSellingPlanLabel(null); // One time
            }
          }
        } else {
          const ul = CartHelper.createSellingPlanLabelElForCartItem(SellingPlanHelper.getSellingPlanLabel(sellingPlan?.id));
          item.querySelector('.main-top-left').appendChild(ul);
        }

        // Update price of each cart item (drawer)
        const priceEl = item.querySelector('.price');
        priceEl.innerHTML = CartHelper.formatMoney(foundCartItem.final_price);

        // Update subtotal price
        const subtotalEl = document.querySelector('#slidecarthq .slidecart-subtotal');
        subtotalEl.textContent = CartHelper.formatMoney(totalPrice);
      }
    }

    static cartChangeViaQuantitySpinnerEventHandler() {
      const quantityIndicatorInputs = document.querySelectorAll('#slidecarthq .items .item .quantity-selector input[type="text"]');
      for(const quantityIndicatorInput of quantityIndicatorInputs) {
        const originalSetter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set
        Object.defineProperty(quantityIndicatorInput, 'value', {
          set: function(v) {
            originalSetter.call(this, v);
            CartHelper.updateCartUI();
          }
        });
      }
    }
  }


  class SellingPlanSelector extends HTMLElement {

    constructor() {
      super();

      const shadow = this.attachShadow({ mode: 'open' });
      this.subscriptionChoice = 'weekly';

      const container = document.createElement('div');
      container.classList.add('selling-plan-selector');

      const title = document.createElement('h5');
      title.classList.add('selling-plan--title');
      const titleText = document.createTextNode('Is this a one-time order or subscription?');
      title.append(titleText);

      container.append(title);

      const subscribeRadioGroup = document.createElement('label');
      subscribeRadioGroup.classList.add('radio-group');
      subscribeRadioGroup.classList.add('active');

      this.subscribeRadio = document.createElement('input');
      this.subscribeRadio.type = 'radio';
      this.subscribeRadio.name = 'subscribe';
      this.subscribeRadio.checked = true;

      const subscribeRadioText = document.createTextNode('Subscribe and get free delivery');

      const onetimeRadioGroup = document.createElement('label');
      onetimeRadioGroup.classList.add('radio-group');

      this.oneTimeRadio = document.createElement('input');
      this.oneTimeRadio.type = 'radio';
      this.oneTimeRadio.name = 'subscribe';

      const onetimeRadioText = document.createTextNode('One time');

      const subscriptionOptionsContainer = document.createElement('div');
      subscriptionOptionsContainer.classList.add('subscription-options');

      const weeklyRadioGroup = document.createElement('label');
      weeklyRadioGroup.classList.add('radio-group-child');

      this.weeklyRadio = document.createElement('input');
      this.weeklyRadio.type = 'radio';
      this.weeklyRadio.name = 'subscription_type';
      this.weeklyRadio.checked = true;
      this.weeklyRadio.dataset.value = true;

      const weeklyText = document.createTextNode('Every week');

      const fortnightlyRadioGroup = document.createElement('label');
      fortnightlyRadioGroup.classList.add('radio-group-child');

      this.fortnightlyRadio = document.createElement('input');
      this.fortnightlyRadio.type = 'radio';
      this.fortnightlyRadio.name = 'subscription_type';

      const fortnightlyText = document.createTextNode('Every 2 weeks');

      subscribeRadioGroup.appendChild(this.subscribeRadio);
      subscribeRadioGroup.appendChild(subscribeRadioText);

      onetimeRadioGroup.appendChild(this.oneTimeRadio);
      onetimeRadioGroup.appendChild(onetimeRadioText);

      weeklyRadioGroup.appendChild(this.weeklyRadio);
      weeklyRadioGroup.appendChild(weeklyText);
      subscriptionOptionsContainer.appendChild(weeklyRadioGroup);

      fortnightlyRadioGroup.append(this.fortnightlyRadio);
      fortnightlyRadioGroup.append(fortnightlyText);
      subscriptionOptionsContainer.appendChild(fortnightlyRadioGroup);

      container.appendChild(subscribeRadioGroup);
      container.appendChild(subscriptionOptionsContainer);
      container.appendChild(onetimeRadioGroup);

      shadow.innerHTML = `
                <style>
                    .selling-plan-selector {
                        display: flex;
                        flex-direction: column;
                        width: 100%;
                        margin-bottom: 32px;
                    }
                    .selling-plan--title {
                        font-size: 15px;
                        font-family: Obviously-Bold, sans-serif;
                        margin-bottom: 32px;
                    }
                    .subscription-options {
                        margin-top: 4px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        margin-bottom: 20px;
                        height: auto;
                        overflow: hidden;
                        transition: height 150ms, margin-top 150ms;
                    }
                    .radio-group {
                        border: solid 2px #dcdcdc;
                        padding: 11px 10px;
                        display: block;
                        margin-bottom: 5px;
                        border-radius: 4px;
                        font-size: 10pt;
                        color: #0f2a06;
                        cursor: pointer;
                        transition: border-color 150ms;
                    }
                    .radio-group.active {
                        border-color: #8080d2;
                    }
                    .radio-group-child {
                        width: calc(42% - 5px);
                        font-size: 10pt;
                        text-align: center;
                    }
                    .subscription-options:not(:has(input[data-value='true'])) {
                        height: 0;
                        margin-top: 0;
                    }
                    .radio-group input[type='radio'],
                    .radio-group-child input[type='radio'] {
                        margin: 3px 5px;
                    }
                    .radio-group.disabled,
                    .radio-group-child.disabled {
                        border: solid 2px #dcdcdc;
                    }
                </style>
            `;
      shadow.append(container);

      this.onSelectSubscribeDefault = this.onSelectSubscribeDefault.bind(this);
      this.onSelectOneTime = this.onSelectOneTime.bind(this);
      this.onSelectFortnightly = this.onSelectFortnightly.bind(this);
      this.resetSelections = this.resetSelections.bind(this);
      this.setActive = this.setActive.bind(this);
    }

    updateSubscriptionOnCartUpdate() {
      // check if items of drawer have different subscription type
      const subscriptionLabels = document.querySelectorAll('#slidecarthq .items .item:has(.properties-key-value-value)'); // edited by AMP
      const items = document.querySelectorAll('#slidecarthq .item');
      let cartItemsAndSubscriptionLabelsHaveDifferentCount = items.length && items.length !== subscriptionLabels.length;

      if (cartItemsAndSubscriptionLabelsHaveDifferentCount) {
        this.attachSellingPlanIDToCart(window.activeSellingPlanId);
      }
    }

    connectedCallback() {
      this.subscribeRadio.addEventListener('change', this.onSelectSubscribeDefault.bind(this));
      this.oneTimeRadio.addEventListener('change', this.onSelectOneTime.bind(this));
      this.weeklyRadio.addEventListener('change', this.onSelectSubscribeDefault.bind(this));
      this.fortnightlyRadio.addEventListener('change', this.onSelectFortnightly.bind(this));
      document.addEventListener('subscription:updated', CartHelper.updateCartUI);
      document.addEventListener('cart:updated', this.updateSubscriptionOnCartUpdate.bind(this));
      document.addEventListener('subscription:updated', CartDrawerSubmitButtonHandler.listen);
      this.onLoad();
      CartHelper.cartChangeViaQuantitySpinnerEventHandler();
    }

    disconnectedCallback() {
      this.subscribeRadio.removeEventListener('change', this.onSelectSubscribeDefault.bind(this));
      this.oneTimeRadio.removeEventListener('change', this.onSelectOneTime.bind(this));
      this.weeklyRadio.removeEventListener('change', this.onSelectSubscribeDefault.bind(this));
      this.fortnightlyRadio.removeEventListener('change', this.onSelectFortnightly.bind(this));
      document.removeEventListener('subscription:updated', CartHelper.updateCartUI);
      document.removeEventListener('cart:updated', this.updateSubscriptionOnCartUpdate.bind(this));
    }

    setLoading(isLoading) {
      const inputs = [
        this.subscribeRadio,
        this.oneTimeRadio,
        this.weeklyRadio,
        this.fortnightlyRadio,
      ];

      for (let input of inputs) {
        input.ariaDisabled = isLoading;

        if (isLoading) {
          input.setAttribute('disabled', true);
        } else {
          input.removeAttribute('disabled');
        }
      }

      if (isLoading) {
        this.subscribeRadio.parentElement.classList.add('disabled');
        this.oneTimeRadio.parentElement.classList.add('disabled');
      } else {
        this.subscribeRadio.parentElement.classList.remove('disabled');
        this.oneTimeRadio.parentElement.classList.remove('disabled');
      }
    }

    resetSelections() {
      this.shadowRoot.querySelectorAll('input[type="radio"').forEach(el => {
        el.checked = false;
        el.dataset.value = false;
      });
      this.shadowRoot.querySelectorAll('label').forEach(el => {
        el.classList.remove('active');
      });
    }

    setActive(e) {
      this.resetSelections();
      e.target.checked = true;
      e.target.dataset.value = true;

      if (e.target.name === 'subscription_type') {
        const parent = this.subscribeRadio;
        parent.parentElement.classList.add('active');
        parent.checked = true;
      }

      if (e.target === this.subscribeRadio) {
        const weekly = this.weeklyRadio;
        const fortnightly = this.fortnightlyRadio;
        if (!weekly.checked && !fortnightly.checked) {
          weekly.checked = true;
          weekly.dataset.value = true;
        }
      }

      if (e.target.name === 'subscribe') {
        e.target.parentElement.classList.add('active');
      }
    }

    setActiveUsingSellingPlan(sellingPlanId) {
      switch (sellingPlanId) {
        case sellingPlan.weekly:
          this.weeklyRadio.checked = true;
          this.subscribeRadio.checked = true;
          this.subscribeRadio.classList.add('active');

          this.oneTimeRadio.checked = false;
          this.oneTimeRadio.parentElement.classList.remove('active');
          break;
        case sellingPlan.fortnightly:
          this.fortnightlyRadio.checked = true;
          this.subscribeRadio.checked = true;
          this.subscribeRadio.classList.add('active');

          this.oneTimeRadio.checked = false;
          this.oneTimeRadio.parentElement.classList.remove('active');
          break;
      }
      window.activeSellingPlanId = sellingPlanId;
    }

    async onLoad() {
      this.setLoading(true);
      try {
        const data = await SellingPlanHelper.getCartData();

        // Check if there's existing selling plan ID on items
        let existing_selling_plan_id;
        if (
          data.items.some(item => {
            existing_selling_plan_id = item.selling_plan_allocation?.selling_plan?.id;
            return item.selling_plan_allocation?.selling_plan?.id;
          })
        ) {
          window.activeSellingPlanId = existing_selling_plan_id;
          this.setActiveUsingSellingPlan(existing_selling_plan_id);
          return;
        } else {
          this.subscribeRadio.checked = true;
          const event = new Event('change', { bubbles: true });
          this.subscribeRadio.dispatchEvent(event);
        }
      } catch (error) {
        console.error('Error: ', error);
      } finally {
        this.setLoading(false);
      }
    }

    async attachSellingPlanIDToCart(sellingPlanId) {
      window.activeSellingPlanId = sellingPlanId;
      this.setLoading(true);
      try {
        await SellingPlanHelper.attachSellingPlanIDToCart(sellingPlanId);
      } catch (error) {
        console.error('Error: ', error);
      } finally {
        this.setLoading(false);
      }
    }

    async onSelectSubscribeDefault(e) {
      this.setActive(e);
      await this.attachSellingPlanIDToCart(sellingPlan.weekly);
    }

    async onSelectOneTime(e) {
      this.setActive(e);
      await this.attachSellingPlanIDToCart(sellingPlan.oneTime);
    }

    async onSelectFortnightly(e) {
      this.setActive(e);
      await this.attachSellingPlanIDToCart(sellingPlan.fortnightly);
    }
  }

  if (!customElements.get('selling-plan-selector')) {
    customElements.define('selling-plan-selector', SellingPlanSelector);

    function attachSellingPlanSelectorUI() {
      cartCheckoutTriggerObserver.observe(document.querySelector('#slidecarthq'), { childList: true, subtree: true });

      $('#storePickupApp').append('<selling-plan-selector />');
      const button = document.querySelector('button[value="Checkout"][name="checkout"]');
      button?.setAttribute('disabled', true);
    }

    const sellingPlanSelectorObserver = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.target.id === 'storePickupApp') {
          if (!document.querySelector('selling-plan-selector')) {
            attachSellingPlanSelectorUI();
          }
        }
      }
    });
    sellingPlanSelectorObserver.observe(document.body, { childList: true, subtree: true });

    const cartCheckoutTriggerObserver = new MutationObserver(mutations => {
      for (const mutation of mutations) {
        if (mutation.target.id === 'storePickupApp') {
          cartCheckoutTriggerObserver.disconnect();
        }
      }
    });
  }

});